module.exports = __webpack_public_path__ + "img/google-play-badge.b4de0cf.svg";